import React from 'react';
import { Platform, Dimensions, PixelRatio } from 'react-native';

function computePixelScale(deviceWidth) {
	if(deviceWidth >= 768) return 1.5;
	if(deviceWidth >= 375) return 1.1;
	return 1;
}

function computePixelScaleV2(deviceHeight) {
	if (deviceHeight >= 900) {
		return 1.45;
	}
	if (deviceHeight >= 800) {
		return 1.4;
		// return 1.5;
		// return 1.6;
	}
	if (deviceHeight >= 700) {
		return 1.37;
		// return 1.47;
		// return 1.55;
	}
	if (deviceHeight >= 650) {
		return 1.33;
		// return 1.43;
		// return 1.45;
	}
	if (deviceHeight >= 600) {
		return 1.3;
		// return 1.43;
		// return 1.45;
	}
	if (deviceHeight >= 550) {
		return 1.25;
		// return 1.35;
		// return 1.3;
	}
	if (deviceHeight >= 500) {
		return 1.2;
		// return 1.35;
		// return 1.3;
	}
	if (deviceHeight >= 450) {
	//   return 1.25;
		return 1.1;
	}
	if (deviceHeight >= 400) {
		//   return 1.25;
			return 1;
	}
	return 1;
}

// On mobile web (this app also ships as a website via react-native-web/expo),
// window.innerHeight/Dimensions('window') report the layout viewport, which does NOT
// shrink to account for the browser's own floating UI (e.g. Chrome iOS's bottom bar).
// window.visualViewport reports the actually-visible area and updates as that browser
// chrome expands/collapses, so prefer it on web when available.
function getWebVisualViewportSize() {
	if (typeof window === 'undefined' || !window.visualViewport) {
		return null;
	}
	return {
		width: window.visualViewport.width,
		height: window.visualViewport.height,
	};
}

const initialWebViewport = Platform.OS === 'web' ? getWebVisualViewportSize() : null;
const deviceWidth=Math.round(initialWebViewport ? initialWebViewport.width : Dimensions.get('window').width);
const deviceHeight=Math.round(initialWebViewport ? initialWebViewport.height : Dimensions.get('window').height);

const Device = {
	getSize(size){
		//Scale pixel up for tablets
		return Math.round(PixelRatio.roundToNearestPixel(size * this.pixelScale));
	},
	getRatio(size) {
		//Scale pixel up for tablets
		return size * this.pixelScaleV2;
	},
	pixelScale: computePixelScale(deviceWidth),
	pixelScaleV2: computePixelScaleV2(deviceHeight),
	isSmallScreen: deviceWidth < 375,
	isTablet: deviceWidth >= 768,
	isBefore23: Platform.Version < 23,
	isBefore22: Platform.Version < 22,
	isBefore21: Platform.Version < 21,
	isBefore19: Platform.Version < 19,
	isAfter21: Platform.Version >= 21,
	is16: Platform.Version === 16,
	is21: Platform.Version === 21,
	is22: Platform.Version === 22,
	is23: Platform.Version === 22,
	isIOS: Platform.OS === 'ios',
	isAndroid: Platform.OS === 'android',
	isWeb: Platform.OS === 'web',
	width: deviceWidth,
	height: deviceHeight,
}

const sizeListeners = new Set();

// Lets a component re-render itself when Device.width/height changes at runtime
// (e.g. a mobile browser's floating toolbar collapsing while a screen is already open),
// instead of only picking up the corrected size on its next unrelated render.
// Returns an unsubscribe function.
Device.addSizeListener = function(listener) {
	sizeListeners.add(listener);
	return () => sizeListeners.delete(listener);
};

// On some devices (notably Android cold starts), the first Dimensions.get('window')
// read above happens before the native window has finished settling insets, so it can
// be off. Once a real size change fires, sync Device's cached values in place so
// consumers reading Device.width/height/getSize() on the next render pick up the
// corrected size without needing a manual app refresh.
function applyDeviceSize(newWidth, newHeight) {
	newWidth = Math.round(newWidth);
	newHeight = Math.round(newHeight);

	if (newWidth === Device.width && newHeight === Device.height) {
		return;
	}

	Device.width = newWidth;
	Device.height = newHeight;
	Device.pixelScale = computePixelScale(newWidth);
	Device.pixelScaleV2 = computePixelScaleV2(newHeight);
	Device.isSmallScreen = newWidth < 375;
	Device.isTablet = newWidth >= 768;

	sizeListeners.forEach((listener) => listener(newWidth, newHeight));
}

Dimensions.addEventListener('change', ({ window }) => {
	applyDeviceSize(window.width, window.height);
});

if (Platform.OS === 'web' && typeof window !== 'undefined' && window.visualViewport) {
	window.visualViewport.addEventListener('resize', () => {
		applyDeviceSize(window.visualViewport.width, window.visualViewport.height);
	});
}

// module.exports = Device;
export default Device
